import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'invite-users');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'mass_invitations',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/invitationUserToCommunity.js